import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';

import { FC } from 'react';
import { Container } from './overview.styles';
import PatientFeedback from './patient-feedback';
import PatientInfo from './patient-info';
import Visits from './visits';
import { AlertsSection } from './sections/alerts/alerts-section';
import TreatmentPlans from "./treatmentplans";
import { PatientConnect365 } from "./patient-connect-365";

export const OverviewView: FC = () => {
  const { contactDetails } = usePatientProfile();

  if (!contactDetails) return null;

  return (
    <Container>
      <div>
        <PatientInfo />
        <PatientFeedback />
      </div>
      <div>
        <PatientConnect365 />
        <AlertsSection />
        <Visits />
        <TreatmentPlans />
      </div>
    </Container>
  );
};
